import { IEventSaveLoggerlist } from 'lib/EventsProvider/@types';

export interface IEventLogsProps {
  open?: boolean;
  eventList?: IEventSaveLoggerlist[];
  onClose?: () => void;
  onOpen?: () => void;
}

export enum EventLogsEAnchor {
  TOP = 'top',
  LEFT = 'left',
  BOTTOM = 'bottom',
  RIGHT = 'right',
}

export interface IJsonEvents {
  [x: string]: IEventSaveLoggerlist;
}
